import React from 'react';
import axios from 'axios';
import { API_HOST } from '../consts';
import { Form } from 'informed';
import { get, debounce } from 'lodash';
import InputSelect from '../components/inputs/InputSelect';
import InputSelectAsync from '../components/inputs/InputSelectAsync';
import InputTextArea from '../components/inputs/InputTextArea';
import InputText from '../components/inputs/InputText';
import InputSelectAsyncCreatable from '../components/inputs/InputSelectAsyncCreatable';
import InputDate from '../components/inputs/InputDate';
import InputSpan from '../components/inputs/InputSpan';
import InputCheckbox from '../components/inputs/InputCheckbox';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  IconButton,
  Button
} from '@material-ui/core';
import { FormSeparator, } from '../pages/avaliacoes/Styled/ItemStyles';
import { ThemeContext } from 'styled-components'
import { TrackGoogleAnalyticsEvent } from '../utils/googleAnalytics';
import { ClickAllObjects, ClickAllObjectsAction } from '../utils/googleAnalytics/events/Itens/EventAllObjects';

const mapResponse = ({ id, descricao }) => ({
  value: id,
  label: descricao
});

const mapMatrizReferencia = ({ id, nome }) => ({
  value: id,
  label: nome
});

const mapEncomenda = mapMatrizReferencia;

class BaseFiltroAvancadoListaItem extends React.Component {
  constructor(props) {
    super(props);
    this.firstTimeOpening = true;
    this.getCursoIdInitial = true;
    this.onOpened = this.onOpened.bind(this);
    this.state = { isPublic: false, isChecked: true };
    this.handleCheck = this.handleCheck.bind(this);

  }
  handleCheck(e) {
    this.setState({
      isPublic: e.target.checked
    });
  }

  state = {
    exame: [],
    matriz_referencia: [],
    area_conhecimento: [],
    habilidades: [],
    criado_por: [],
    status: [],
    tipo: [],
    dificuldade: [],
    filtros: [],
    itens: [],
    periodo: [],
    curso: [],
    componenteCurricular: [],
    showItens: false,
    itensChecked: [],
    metadata: {},
    codigoId: '',
    areasConhecimentoId: '',
    componenteCurricularId: '',
    anoId: '',
    matrizReferenciaId: '',
    cursoId: '',
    habilidadeId: '',
    habilidadeSearch: '',
    avaliacaoPPI: false,
    idCursoInitial: '',
    valueFilterselect: {},
    valueFilterselectBase: {},
    valueMatrizReferencia: {},
    valueHabilidade: {},
    valuePeriodo: {},
    valueComponenteCuricular: {},
    valueCurso: {},
    me: {}
  };

  onOpened() {
    setTimeout(() => {
      if (this.firstTimeOpening) {
        this.firstTimeOpening = false;
        Promise.all([
          this.fetchMetadata(),
          this.fetchExames(),
          this.fetchAreasConhecimento(),
          this.fetchCriadoPor(),
          this.fetchComponenteCurricular(),
          this.fetchMatrizReferencia(),
          this.fetchCurso(),
          this.fetchPeriodo(),
          this.fetchStatus(),
          this.fetchTipo(),
          this.fetchDificuldades(),
          this.fetchMe(),
          this.fetchHabilidade(),

        ]).then(() => {

          const { initialValues } = this.props;
          this.formApi.setValues({ ...initialValues, ...this.values });


          this.getAvaliationPPI(this.formApi);
          this.getAvaliation(this.formApi)

        });
      }
    }, 1000);
  };

  fetchMe() {
    try {
      const token = localStorage.getItem('token');
      axios
        .get(`${API_HOST}/login/me`, {
          headers: {
            Authorization: `JWT ${token}`
          }
        })
        .then((response) => {
          this.setState({ me: response.data });
        })
    } catch (error) {
      console.error(error);
    }
  }

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickAllObjects + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickAllObjectsAction,
      label,
    );
  };


  componentDidUpdate() {
    if (this.getCursoIdInitial) {
      if (this.state.cursoID) {
        axios.get(`${API_HOST}/core/curso?id=${this.state.cursoID}`).then((response) => {
          this.setState({ idCursoInitial: response.data[0].codigo });
        });
        this.fetchMatrizReferencia()
        this.getCursoIdInitial = false
      }
    }
  };

  fetchMetadata() {
    axios.get(`${API_HOST}/params/param?model=avaliacao`).then((response) => {
      this.setState({ metadata: this.mapMetadata(response.data) });
    });
  };

  mapMetadata(metadata) {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });

    return mapped;
  };

  onCheckboxClick(_, id) {
    const { itensChecked } = this.state;
    itensChecked.push(id);
    this.setState({ itensChecked });
  };

  shouldDisplay(field) {
    const { metadata } = this.state;
    return get(metadata, field) > 0;
  };

  getValues(v) {
    const values = { ...v };
    this.asyncSelects.forEach((select) => {
      if (values[select]) {
        values[select] = get(values, `${select}.value`);
      }
    });

    return values;
  };

  asyncSelects = [
    'matriz_referencias',
    'competencia',
    'habilidades',
    'encomenda',
    'componente_curriculares',
    'curso',
    'periodos'
  ];

  fetchExames() {
    const params = { type: 'itens' }
    axios.get(`${API_HOST}/core/exame/options_filters`, { params }).then((response) => {
      this.setState({
        exame: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  };

  fetchAreasConhecimento() {
    const params = { type: 'itens' }
    axios.get(`${API_HOST}/core/area_conhecimento/options_filters`, { params }).then((response) => {
      this.setState({
        area_conhecimento: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  };

  fetchDificuldades() {
    axios.get(`${API_HOST}/itens/dificuldade`).then((response) => {
      this.setState({
        dificuldade: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  };

  fetchCompetencias = debounce((input, callback) => {
    axios
      .get(`${API_HOST}/matriz_referencia/competencia`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        const options = response.data.results.map(mapResponse);
        callback(null, { options });
      });
  }, 1000);

  fetchCriadoPor() {
    axios.get(`${API_HOST}/itens/criado_por`).then((response) => {
      this.setState({
        criado_por: response.data.map((item) => ({
          value: item.id,
          label: `${item.first_name}  ${item.last_name}`
        }))
      });
    });
  };

  fetchStatus() {
    axios.get(`${API_HOST}/itens/status/options_filters`).then((response) => {
      this.setState({
        status: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  };

  fetchTipo() {
    const { tipoId } = this.props;

    axios.get(`${API_HOST}/itens/tipo/options_filters`).then((response) => {
      if (tipoId) {
        const data = response.data.results ? response.data.results : response.data;
        this.handleTipo(data.map(x => ({ value: x.id, label: x['descricao'] })))
      }
      else {
        this.setState({
          tipo: response.data.map((item) => ({
            value: item.id,
            label: item.descricao
          }))
        });
      }
    });
  };

  handleTipo(data) {
    const { tipoId } = this.props;

    if (tipoId === '1') {
      this.setState({ tipo: data.filter((item) => [1, 2, 6, 12, 4, 5, 3].includes(item.value)) })
    }
    else if (tipoId === '2') {
      this.setState({ tipo: data.filter((item) => [7, 9, 11, 10].includes(item.value)) })
    }
  };

  fetchMatrizReferencia = debounce((input, callback) => {
    const { codigoId, areasConhecimentoId, anoId, componenteCurricularId } =
      this.state;

    const params = {
      status: 1,
      page_size: 100,
      type: 'itens',
      etapa_id: anoId,
    };

    if (componenteCurricularId) {
      params.disciplina_id = componenteCurricularId
    }

    if (codigoId) {
      params.curso__id = codigoId;
    } else {
      if (this.state.cursoID) {
        params.curso__id = this.state.idCursoInitial;
      }
      else {
        params.curso__id = '';
      }
    }

    if (areasConhecimentoId) {
      params.areas_conhecimento__id = areasConhecimentoId;
    } else {
      params.areas_conhecimento__id = '';
    }

    axios
      .get(`${API_HOST}/matriz_referencia/matriz_referencia/options_filters`, { params })
      .then((response) => {
        const options = response.data.map(mapMatrizReferencia);
        this.setState({ matriz_referencia: options });
        callback(null, { options });
      })
      .catch((error) => console.error(error));
  }, 1000);

  fetchComponenteCurricular = debounce((input, callback) => {
    const { areasConhecimentoId } = this.state;
    const params = { type: 'itens', area_conhecimento_id: areasConhecimentoId || '' };
    axios.get(`${API_HOST}/core/componente_curricular/options_filters`, { params }).then((response) => {
      const options = response.data.map((mapResponse) => ({
        value: mapResponse.id,
        label: mapResponse.descricao
      }));
      this.setState({ componenteCurricular: options });
      // callback(null, { options })
    });
  }, 1000);

  // fetchCurso = debounce((input, callback) => {
  //   const params = { type: 'itens' }
  //   axios
  //     .get(`${API_HOST}/core/curso/options_filters`, { params })
  //     .then((response) => {
  //       const options = response.data.map((mapResponse) => ({
  //         value: mapResponse.id,
  //         label: mapResponse.descricao,
  //         codigo: mapResponse.codigo
  //       }));
  //       callback(null, { options });
  //     })
  //     .catch((error) => console.error(error));
  // }, 1000);

  fetchPeriodo = debounce((input, callback) => {
    const { cursoId } = this.state;

    if (cursoId) {
      axios
        .get(`${API_HOST}/core/periodo/${cursoId}/filter_curso`)
        .then((response) => {
          const options = []
          response.data.forEach((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              });
            }
          });
          this.setState({ periodo: options });
          callback(null, { options });
        })
        .catch((error) => console.error(error));
    } else {
      const params = { type: 'itens' }
      axios
        .get(`${API_HOST}/core/periodo/options_filters`, { params })
        .then((response) => {
          const options = [];
          response.data.forEach((mapResponse) => {
            if (mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao
              });
            }
          });

          this.setState({ periodo: options });
          callback(null, { options });
        })
        .catch((error) => console.error(error));
    }
  }, 1000);

  fetchHabilidade = debounce((input, callback) => {
    const {
      areasConhecimentoId,
      componenteCurricularId,
      anoId,
      matrizReferenciaId,
      habilidadeSearch
    } = this.state;

    const params = {
      area_conhecimento_id: areasConhecimentoId,
      matriz_id: matrizReferenciaId,
      search: habilidadeSearch,
      type: "itens"
    };

    if (componenteCurricularId) {
      params.disciplina = componenteCurricularId
    }
    if (anoId) {
      params.etapa_id = anoId
    }

    axios
      .get(
        `${API_HOST}/matriz_referencia/habilidade/options_filters`, { params }
      )
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`
        }));
        this.setState({ habilidades: options });

      });
  }, 600);

  fetchEncomendas = debounce((input, callback) => {
    axios
      .get(`${API_HOST}/encomenda/encomenda`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        const options = response.data.results.map(mapEncomenda);
        callback(null, { options });
      });
  }, 1000);

  fetchPalavrasChave(input, callback) {
    axios
      .get(`${API_HOST}/itens/palavra_chave`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        callback(null, {
          options: response.data.results.map((x) => ({
            value: String(x.id),
            label: x.descricao
          }))
        });
      });
  };

  fetchItens() {
    axios.get(`${API_HOST}/itens/item`).then((response) => {
      this.setState({
        itens: response.data.results.map((item) => ({
          id: item.id,
          descricao: item.situacao_problema
        })),
        showItens: true
      });
    });
  };

  toggle = () => {
    const { toggle } = this.props;
    this.values = this.formApi.getState().values;
    toggle();
  };

  handleSubmit = (values) => {
    this.buscarItens(this.getValues(values));
  };

  buscarItens(values) {
    return axios.get(`${API_HOST}/itens/item`, { params: values });
  };

  renderList() {
    return null;
  };

  renderFooter() {
    return null;
  };

  fetchCurso() {
    const params = { type: 'itens' }
    axios
      .get(`${API_HOST}/core/curso/options_filters`, { params })
      .then((response) => {
        const options = [];
        response.data.forEach((mapResponse) => {
          if (mapResponse.oculto !== true) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            });
          }
        });

        this.setState({ curso: options });
      })
      .catch((error) => console.error(error));
  };


  getAvaliationPPI = (formApi) => {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      axios
        .get(`${API_HOST}/avaliacoes/avaliacao?id=${this.props.match.params.id}`)
        .then((response) => {
          if (response.data.results[0].nome.includes('PPI')) {
            const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
            const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;
            this.setState({
              avaliacaoPPI: true,
              areaConhecimentoPPI: response.data.results[0].area_conhecimento,
              periodoPPI: response.data.results[0].periodo,
              cursoPPI: response.data.results[0].curso[0],
              componentePPI: response.data.results[0].componente_curricular,
              tipoItemPPI: primeiroTipoItem
            });

            if (this.state.avaliacaoPPI) {
              const newInitialValues = {
                ...this.state.initialValues,
                areas_conhecimento: this.state.areaConhecimentoPPI,
                componente_curricular: this.state.componentePPI,
                tipo: this.state.tipoItemPPI,
                periodo: this.state.periodoPPI,
                curso: this.state.cursoPPI,

              };


              formApi.setValues(newInitialValues);
            }
          }
        })
        .catch((error) => {
          console.error("Erro na requisição:", error);
        });
    } else {
      console.error("Propriedade 'id' não encontrada em this.props.match.params");
    }
  };

  getAvaliation = (formApi) => {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      axios
        .get(`${API_HOST}/avaliacoes/avaliacao?id=${this.props.match.params.id}`)
        .then((response) => {

          const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
          const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;
          const areaConhecimento = response.data.results[0].area_conhecimento;

          let resultado = null;

          if (areaConhecimento === "Linguagens, Códigos e suas Tecnologias") {
            resultado = 1;
          } else if (areaConhecimento === "Matemática e suas Tecnologias") {
            resultado = 2;
          } else if (areaConhecimento === "Ciências da Natureza e suas Tecnologias") {
            resultado = 3;
          } else if (areaConhecimento === "Ciências Humanas e suas Tecnologias") {
            resultado = 4;
          } else if (areaConhecimento === "Ensino Religioso") {
            resultado = 5;
          } else if (areaConhecimento === "Educação Tecnológica") {
            resultado = 6;
          }

          this.setState({

            areaConhecimentoID: resultado,
            periodoID: response.data.results[0].periodo,
            cursoID: response.data.results[0].curso[0],
            componenteID: response.data.results[0].componente_curricular,
            tipoItemID: primeiroTipoItem
          });

          const newInitialValues = {
            ...this.state.initialValues,
            areas_conhecimento: this.state.areaConhecimentoID,
            componente_curricular: this.state.componenteID,
            tipo: this.state.tipoItemID,
            periodo: this.state.periodoID,
            curso: this.state.cursoID,

          };

          formApi.setValues(newInitialValues);

        }

        )
        .catch((error) => {
          console.error("Erro na requisição:", error);
        });
    } else {
      console.error("Propriedade 'id' não encontrada em this.props.match.params");
    }
  };

  onChangeCurso(event) {
    if (event) {
      this.setState({
        codigoId: event.codigo,
        cursoId: event.value,
        cursoPPI: event.value,
        cursoID: event.value
      });
      this.fetchMatrizReferencia();
      this.fetchPeriodo();
    } else {
      this.setState({ codigoId: '', cursoId: '', cursoPPI: '', cursoID: '' });
      this.fetchMatrizReferencia();
      this.fetchPeriodo();
    };

    const curso = { curso: get(event, "value", "") };
    const cursoLabel = get(event, "label", "");
    var changePageFilter = {};

    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var key in curso) {
      changePageFilter[key] = curso[key];
    };

    this.setState({
      valueFilterselectBase: changePageFilter,
      valueCurso: cursoLabel
    })
  };

  onChangePeriodo(event) {
    if (event) {
      this.setState({ anoId: event.value, periodoPPI: event.value, periodoID: event.value });
      this.fetchHabilidade();
      this.fetchMatrizReferencia();
    } else {
      this.fetchMatrizReferencia();
      this.fetchHabilidade();
      this.setState({ anoId: '', periodoPPI: '', anoID: '' })
    };

    const periodo = { periodo: get(event, "value", "") };
    const periodoLabel = get(event, "label", "");
    var changePageFilter = {};

    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var key in periodo) {
      changePageFilter[key] = periodo[key];
    };

    this.setState({
      valueFilterselectBase: changePageFilter,
      valuePeriodo: periodoLabel
    });
  };

  onChangeAreaConhecimento(event) {
    if (event) {
      this.setState({
        areasConhecimentoId: event.value,
        areaConhecimentoPPI: event.value,
        areaConhecimentoID: event.value
      });
      this.fetchMatrizReferencia();
      this.fetchHabilidade();
      this.fetchComponenteCurricular();
    } else {
      this.setState({ areasConhecimentoId: '', areaConhecimentoPPI: '' });
      this.fetchMatrizReferencia();
      this.fetchHabilidade();
      this.fetchComponenteCurricular();
    };

    const area_conhecimento = { area_conhecimento: get(event, "value", "") };
    var changePageFilter = {};

    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var key in area_conhecimento) {
      changePageFilter[key] = area_conhecimento[key];
    };

    this.setState({ valueFilterselectBase: changePageFilter })
  };

  onChangeComponenteCurricular(event) {
    if (event) {
      this.setState({
        componenteCurricularId: event.value,
        componentePPI: event.value,
        componenteID: event.value
      });
      this.fetchHabilidade();
      this.fetchMatrizReferencia();
    } else {
      this.setState({
        componenteCurricularId: '',
        componentePPI: '',
        componenteID: ''
      });
      this.fetchHabilidade();
      this.fetchMatrizReferencia();
    };

    const componente_curricular = { componente_curricular: get(event, "value", "") };
    const componenteCurricularLabel = get(event, "label", "");
    var changePageFilter = {};

    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var key in componente_curricular) {
      changePageFilter[key] = componente_curricular[key];
    };

    this.setState({
      valueFilterselectBase: changePageFilter,
      valueComponenteCuricular: componenteCurricularLabel
    });
  };

  onChangeMatrizReferencia(event) {
    if (event) {
      this.setState({ matrizReferenciaId: event.value });
      this.fetchHabilidade();
    } else {
      this.setState({ matrizReferenciaId: '' });
      this.fetchHabilidade();
    };

    const matrizReferencia = { matriz_referencia: get(event, "value", "") };
    const matrizReferenciaLabel = get(event, "label", "");
    var changePageFilter = {};

    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var key in matrizReferencia) {
      changePageFilter[key] = matrizReferencia[key];
    };

    this.setState({
      valueFilterselectBase: changePageFilter,
      valueMatrizReferencia: matrizReferenciaLabel
    });
  };

  resetForm = () => {
    this.setState({ areasConhecimentoId: '', areaConhecimentoPPI: '', areaConhecimentoID: '' })
    this.setState({ cursoID: '', cursoPPI: '' })
    this.setState({ componenteCurricularId: '', componentePPI: '', componenteID: '' })
    this.setState({ anoId: '', periodoPPI: '', periodoID: '' })
    this.setState({ matrizReferenciaId: '' })
    this.setState({ habilidadeSearch: '' })
    this.setState({ tipoItemPPI: '', tipoItemID: '' })
    this.formApi.reset();
  };

  renderFormObjeto() {
    const {
      exame,
      area_conhecimento,
      criado_por,
      status,
      tipo,
      isChecked,
      matriz_referencia,
      habilidades,
      periodo,
      componenteCurricular,
      curso,
      valueFilterselect,
      valueFilterselectBase,
      me
    } = this.state;

    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        onValueChange={this.onValueChange}
        onSubmit={this.handleSubmit}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >

        <Grid item container xs={12}>
          <Grid item container xs={12}>
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    marginTop: "20px",
                    color: "#262930",
                    fontFamily: "Public Sans",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                  }}
                >
                  Dados da aplicação
                </Typography>
              </Grid>
              <Grid item container xs={12} style={{ marginTop: "1rem" }}>

                <Grid item xs={6}>
                  <InputSelect
                    autoload
                    label="Segmento/Etapa"
                    field="curso"
                    value={
                      get(valueFilterselect, "curso",
                        get(valueFilterselectBase, "curso",
                          this.state.avaliacaoPPI ? (
                            this.state.cursoPPI
                          ) : (
                            this.state.cursoID
                          )
                        )
                      )
                    }
                    onChange={(event) => {
                      const label =  get(event, "label", "Excluído");
                      this.analytcsClick(`Filtro Segmento/Etapa: ${label}`, 'Filter All Objects');
                      this.onChangeCurso(event)
                    }}
                    options={curso}
                  // loadOptions={this.fetchCurso}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputSelect
                    label="Série/Ano"
                    field="periodo"
                    value={
                      get(valueFilterselect, "periodo",
                        get(valueFilterselectBase, "periodo",
                          this.state.avaliacaoPPI ? (
                            this.state.periodoPPI
                          ) : (
                            this.state.periodoID)
                        )
                      )
                    }
                    onChange={(event) => {
                      const label =  get(event, "label", "Excluído");
                      this.analytcsClick(`Filtro Série/Ano: ${label}`, 'Filter All Objects');
                      this.onChangePeriodo(event)
                    }}
                    options={periodo}
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={6}>
                  <InputSelect
                    label="Área do Conhecimento"
                    field="area_conhecimento"
                    value={
                      get(valueFilterselectBase, "area_conhecimento",
                        get(valueFilterselect, "area_conhecimento",
                          this.state.avaliacaoPPI ? (
                            this.state.areaConhecimentoPPI
                          ) : (
                            this.state.areaConhecimentoID
                          )
                        )
                      )
                    }
                    options={area_conhecimento}
                    onChange={(event) => {
                      const label =  get(event, "label", "Excluído");
                      this.analytcsClick(`Filtro Área do Conhecimento: ${label}`, 'Filter All Objects');
                      this.onChangeAreaConhecimento(event)
                    }}
                  />
                </Grid>
                {this.state.cursoID == 6 || this.state.cursoID == 10 ? (
                  <></>
                ) : (
                  <Grid item xs={6}>
                    <InputSelect
                      label="Componente Curricular"
                      field="componente_curricular"
                      value={
                        get(valueFilterselectBase, "componente_curricular",
                          get(valueFilterselect, "componente_curricular",
                            this.state.avaliacaoPPI ? (
                              this.state.componentePPI
                            ) : (
                              this.state.componenteID
                            )
                          )
                        )
                      }
                      onChange={(event) => {
                        const label =  get(event, "label", "Excluído");
                        this.analytcsClick(`Filtro Componente Curricular: ${label}`, 'Filter All Objects');
                        this.onChangeComponenteCurricular(event);
                      }}
                      options={componenteCurricular}
                    />
                  </Grid>)}
              </Grid>
            </Grid>
            <Grid item container xs={12}>

              <Grid item xs={12} style={{ marginTop: "1rem" }}>
                <FormSeparator>
                  <Typography
                    style={{
                      marginTop: "20px",
                      color: "#262930",
                      fontFamily: "Public Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Habilidades
                  </Typography>
                </FormSeparator>
              </Grid>

              <Grid item xs={12} style={{ marginTop: "1rem" }}>
                {this.shouldDisplay('avaliacao.renderMatrizHabilidade') ? (
                  <div style={{ display: 'flex' }}>
                    <Grid item xs={6} >
                      <InputSelect
                        label="Matriz de Referência"
                        field="matriz_referencia"
                        value={
                          get(valueFilterselect, "matriz_referencia") === get(valueFilterselectBase, "matriz_referencia") ? (
                            get(valueFilterselect, "matriz_referencia")
                          ) : (
                            get(valueFilterselectBase, "matriz_referencia")
                          )
                        }
                        onChange={(event) => {
                          const label =  get(event, "label", "Excluído")
                          this.analytcsClick(`Filtro Matriz de Referência: ${label}`, 'Filter All Objects');
                          this.onChangeMatrizReferencia(event)
                        }}
                        options={matriz_referencia}
                      />
                    </Grid>
                    {/* <InputSelectAsync
                      autoload
                      label="Competências"
                      col="col-md-12"
                      field="competencia"
                      loadOptions={this.fetchCompetencias}
                    /> */}
                    <Grid item xs={6}>
                      <InputSelect
                        label="Habilidade"
                        field="habilidade"
                        options={habilidades}
                        value={
                          get(valueFilterselect, "habilidade") === get(valueFilterselectBase, "habilidade") ? (
                            get(valueFilterselect, "habilidade")
                          ) : (
                            get(valueFilterselectBase, "habilidade")
                          )
                        }
                        onChange={(event) => {
                          const label =  get(event, "label", "Excluído")
                          this.analytcsClick(`Filtro Habilidade: ${label}`, 'Filter All Objects');
                          if (!event) {
                            this.setState({ habilidadeSearch: '' });
                            this.fetchHabilidade();
                          }
                          const habilidade = { habilidade: get(event, "value", "") };
                          const habilidadeLabel = get(event, "label", "");
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in habilidade) {
                            changePageFilter[key] = habilidade[key];
                          };

                          this.setState({
                            valueFilterselectBase: changePageFilter,
                            valueHabilidade: habilidadeLabel
                          });
                        }}
                        onInputChange={(event) => {
                          if (event) {
                            this.setState({ habilidadeSearch: event })
                            this.fetchHabilidade()
                          }
                        }}
                      />
                    </Grid>
                  </div>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>

            <Grid item container xs={12}>
              <Grid item xs={12}>
                <FormSeparator>
                  <Typography
                    style={{
                      marginTop: "20px",
                      color: "#262930",
                      fontFamily: "Public Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Classificação
                  </Typography>
                </FormSeparator>
              </Grid>

              <Grid item xs={12} style={{ marginTop: "1rem" }} >
                <div style={{ display: 'flex' }}>
                  <Grid item xs={4} >
                    <InputSelect
                      label={`Tipo do ${this.breadCrumb2}`}
                      field="tipo"
                      options={tipo}
                      value={
                        get(valueFilterselect, "tipo") ? (
                          get(valueFilterselect, "tipo")
                        ) : (
                          get(valueFilterselectBase, "tipo")
                        )
                      }
                      onChange={(event) => {
                        const label =  get(event, "label", "Excluído")
                        this.analytcsClick(`Filtro Tipo do Objeto de aprendizagem: ${label}`, 'Filter All Objects');
                        const tipo = { tipo: get(event, "value", "") };
                        var changePageFilter = {};

                        for (var prop in this.state.valueFilterselectBase) {
                          changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                        };
                        for (var key in tipo) {
                          changePageFilter[key] = tipo[key];
                        };

                        this.setState({
                          tipoItemPPI: event ? event.value : this.setState({ tipoItemPPI: '', tipoItemID: '' }),
                          tipoItemID: event && event.value,
                          valueFilterselectBase: changePageFilter
                        })
                      }}
                    />
                  </Grid>
                  {
                    me && me.logged_group.includes('ADMINISTRADOR') && (
                        <>
                          {this.shouldDisplay('avaliacao.filterStatus') && (
                            <Grid item xs={4}>
                              <InputSelect
                                label={`Status do ${this.breadCrumb2}`}
                                field="status"
                                value={
                                  get(valueFilterselect, "status") ? (
                                    get(valueFilterselect, "status")
                                  ) : (
                                    get(valueFilterselectBase, "status")
                                  )
                                }
                                options={status}
                                onChange={(event) => {
                                  const label =  get(event, "label", "Excluído")
                                this.analytcsClick(`Filtro Tipo do Objeto de aprendizagem: ${label}`, 'Filter All Objects');
                                const status = { status: get(event, "value", "") };
                                  var changePageFilter = {};

                                for (var prop in this.state.valueFilterselectBase) {
                                  changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                                };
                                for (var key in status) {
                                  changePageFilter[key] = status[key];
                                };
                                this.setState({ valueFilterselectBase: changePageFilter });
                              }}
                            />
                          </Grid>
                        )}
                      </>
                    )}
                  {this.shouldDisplay( this.breadCrumb == 'Recursos Pedagógicos'?'avaliacao.filterCategoria':'avaliacao.FilterItemCategoria') && (
                    < Grid item xs={4}>
                      <InputSelect
                        label="Categoria"
                        field="exame"
                        value={
                          get(valueFilterselect, "exame") ? (
                            get(valueFilterselect, "exame")
                          ) : (
                            get(valueFilterselectBase, "exame")
                          )
                        }
                        options={exame}
                        onChange={(event) => {
                          const label =  get(event, "label", "Excluído")
                          const exame = { exame: get(event, "value", "") };
                          this.analytcsClick(`Filtro Categoria: ${label}`, 'Filter All Objects');
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in exame) {
                            changePageFilter[key] = exame[key];
                          };

                          this.setState({ valueFilterselectBase: changePageFilter });
                        }}
                      />
                    </Grid>
                  )}
                </div>

                <div style={{ display: 'flex' }}>
                  {this.shouldDisplay('avaliacao.filterCode') && (
                    <Grid item xs={6} style={{ marginRight: '8px' }}>
                      <InputText
                        label={`Código do ${this.breadCrumb2}`}
                        field="id"
                        value={
                          get(valueFilterselect, "id") ? (
                            get(valueFilterselect, "id")
                          ) : (
                            get(valueFilterselectBase, "id")
                          )
                        }
                        onBlur= {(e)=>{
                          const label =  e.target.value == '' ? 'Exluído' : e.target.value;
                          this.analytcsClick(`Filtro Código do Objeto de aprendizagem: ${label}`, 'Filter All Objects');
                        }}
                        onChange={(event) => {
                          const id = { id: event ? (event) : ("") };
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in id) {
                            changePageFilter[key] = id[key];
                          };

                          this.setState({ valueFilterselectBase: changePageFilter })
                        }}
                      />
                    </Grid>
                  )}

                  {this.shouldDisplay('avaliacao.filterExternalId') && (
                    <Grid item xs={6} style={{ marginLeft: '8px' }}>
                      <InputText
                        label="Código Externo"
                        field="external_id"
                        value={
                          get(valueFilterselect, "external_id") ? (
                            get(valueFilterselect, "external_id")
                          ) : (
                            get(valueFilterselectBase, "external_id")
                          )
                        }
                        onBlur= {(e)=>{
                          const label =  e.target.value == '' ? 'Exluído' : e.target.value;
                          this.analytcsClick(`Filtro Código Externo: ${label}`, 'Filter All Objects');
                        }}
                        onChange={(event) => {
                          const external_id = { external_id: event ? (event) : ("") };
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in external_id) {
                            changePageFilter[key] = external_id[key];
                          };

                          this.setState({ valueFilterselectBase: changePageFilter })
                        }}
                      />
                    </Grid>
                  )}
                </div>

                {this.shouldDisplay('avaliacao.elaborador') && (
                  <Grid item xs={4}>
                    <InputSelect
                      label="Elaborador"
                      field="criado_por"
                      options={criado_por}
                      value={
                        get(valueFilterselect, "criado_por") ? (
                          get(valueFilterselect, "criado_por")
                        ) : (
                          get(valueFilterselectBase, "criado_por")
                        )
                      }
                      onChange={(event) => {
                        const criado_por = { criado_por: get(event, "value", "") };
                        var changePageFilter = {};

                        for (var prop in this.state.valueFilterselectBase) {
                          changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                        };
                        for (var key in criado_por) {
                          changePageFilter[key] = criado_por[key];
                        };

                        this.setState({ valueFilterselectBase: changePageFilter })
                      }}
                    />
                  </Grid>
                )}


                {this.shouldDisplay('avaliacao.filtersWithDate') ? (
                  <>
                    <Grid item xs={4}>
                      <InputDate
                        label="Itens criados a partir de"
                        field="min_criado_em"
                        type="date"
                        value={
                          get(valueFilterselect, "min_criado_em") ? (
                            get(valueFilterselect, "min_criado_em")
                          ) : (
                            get(valueFilterselectBase, "min_criado_em")
                          )
                        }
                        onChange={(event) => {
                          const min_criado_em = { min_criado_em: get(event, "value", "") };
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in min_criado_em) {
                            changePageFilter[key] = min_criado_em[key];
                          };

                          this.setState({ valueFilterselectBase: changePageFilter })
                        }}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <InputDate
                        label="Itens criados até"
                        field="max_criado_em"
                        type="date"
                        value={
                          get(valueFilterselect, "max_criado_em") ? (
                            get(valueFilterselect, "max_criado_em")
                          ) : (
                            get(valueFilterselectBase, "max_criado_em")
                          )
                        }
                        onChange={(event) => {
                          const max_criado_em = { max_criado_em: get(event, "value", "") };
                          var changePageFilter = {};

                          for (var prop in this.state.valueFilterselectBase) {
                            changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                          };
                          for (var key in max_criado_em) {
                            changePageFilter[key] = max_criado_em[key];
                          };

                          this.setState({ valueFilterselectBase: changePageFilter })
                        }}
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

              </Grid>
            </Grid>

            <Grid item container xs={12}>
              <Grid item xs={12}>
                <FormSeparator>
                  <Typography
                    style={{
                      marginTop: "20px",
                      color: "#262930",
                      fontFamily: "Public Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Visualização
                  </Typography>
                </FormSeparator>
              </Grid>

              {this.shouldDisplay('avaliacao.renderMochilaTopicoSubtopico') ? (
                <div className="row modal-body-inside">
                  <InputText label="Mochila" field="mochila" col="col-md-4" />
                  <InputText label="Topico" field="topico" col="col-md-4" />
                  <InputText label="SubTopico" field="subtopico" col="col-md-4" />
                </div>
              ) : (
                <></>
              )}

              <Grid item xs={12} style={{ marginTop: "2rem" }}>
                <InputCheckbox
                  required
                  label={`Mostrar somente ${this.breadCrumb3} nunca utilizados em avaliações`}
                  field="nunca_utilizados"
                  onChange={(e)=>{
                    const label =  e.target.checked ? 'Ativado' : 'Desativado';
                    this.analytcsClick(`Filtro Itens nunca utilizados em avaliações: ${label}`, 'Filter All Objects');
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <InputCheckbox
                  required
                  label={`Mostrar somente ${this.breadCrumb3} públicos`}
                  field="publico"
                  onChange={(e) => {
                    const label =  e.target.checked ? 'Ativado' : 'Desativado';
                    this.analytcsClick(`Filtro Itens públicos: ${label}`, 'Filter All Objects');
                    this.setState({ isChecked: e.target.checked })
                  }}
                  checked={isChecked}
                  value={isChecked}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} >
              {this.shouldDisplay('avaliacao.filterForText') ? (
                <>
                  <Grid item xs={6}>
                    <InputTextArea
                      label="Enunciado"
                      field="enunciado"
                      value={
                        get(valueFilterselect, "enunciado") ? (
                          get(valueFilterselect, "enunciado")
                        ) : (
                          get(valueFilterselectBase, "enunciado")
                        )
                      }
                      onChange={(event) => {
                        const enunciado = { enunciado: event ? (event) : ("") };
                        var changePageFilter = {};

                        for (var prop in this.state.valueFilterselectBase) {
                          changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                        };
                        for (var key in enunciado) {
                          changePageFilter[key] = enunciado[key];
                        };

                        this.setState({ valueFilterselectBase: changePageFilter })
                      }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <InputTextArea
                      label="Alternativa"
                      field="alternativa"
                      value={
                        get(valueFilterselect, "alternativa") ? (
                          get(valueFilterselect, "alternativa")
                        ) : (
                          get(valueFilterselectBase, "alternativa")
                        )
                      }
                      onChange={(event) => {
                        const alternativa = { alternativa: event ? (event) : ("") };
                        var changePageFilter = {};

                        for (var prop in this.state.valueFilterselectBase) {
                          changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                        };
                        for (var key in alternativa) {
                          changePageFilter[key] = alternativa[key];
                        };

                        this.setState({ valueFilterselectBase: changePageFilter })
                      }}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <InputSelectAsyncCreatable
                      multi
                      label="Palavras-chave"
                      field="palavras_chave"
                      loadOptions={this.fetchPalavrasChave}
                      autoload={false}
                      value={
                        get(valueFilterselect, "palavras_chave") ? (
                          get(valueFilterselect, "palavras_chave")
                        ) : (
                          get(valueFilterselectBase, "palavras_chave")
                        )
                      }
                      onChange={(event) => {
                        const palavras_chave = { palavras_chave: event ? (event) : ("") };
                        var changePageFilter = {};

                        for (var prop in this.state.valueFilterselectBase) {
                          changePageFilter[prop] = this.state.valueFilterselectBase[prop];
                        };
                        for (var key in palavras_chave) {
                          changePageFilter[key] = palavras_chave[key];
                        };

                        this.setState({ valueFilterselectBase: changePageFilter })
                      }}
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}

            </Grid>

            <Grid item container xs={12}>
              {this.shouldDisplay('avaliacao.renderEncomendaFilter') ? (
                <>
                  <Grid item xs={4}>
                    <InputSelectAsync
                      label="Título"
                      field="encomenda"
                      loadOptions={this.fetchEncomendas}
                      autoload={false}
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}

              {this.shouldDisplay('avaliacao.renderTCT') ? (
                <>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_bisserial"
                      label="Bisserial"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_bisserial"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_discriminacao"
                      label="Discriminação"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_discriminacao"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_dificuldade"
                      label="Dificuldade (porcentagem de acertos)"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_dificuldade"
                      leftAddon="Máximo"
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}

              {this.shouldDisplay('avaliacao.renderTRI') ? (
                <>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pa"
                      label="A"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pa"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pb"
                      label="B"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pb"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pc"
                      label="C"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pc"
                      leftAddon="Máximo"
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid >
      </Form >
    );
  }

  render() {
    const { isOpen, tipoId } = this.props;
    const themes = this.context;

    switch (tipoId) {
      case '1':
        this.breadCrumb = 'Itens';
        this.breadCrumb2 = 'Item';
        this.breadCrumb3 = 'itens';
        break;
      case '2':
        this.breadCrumb = 'Recursos Pedagógicos';
        this.breadCrumb2 = 'Recurso';
        this.breadCrumb3 = 'recursos pedagógicos';
        break;
      default:
        this.breadCrumb = 'Itens';
        this.breadCrumb2 = 'Item';
        this.breadCrumb3 = 'itens';
        break;
    }

    const styles = (theme) => ({
      root: {
        margin: 0,
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      closeButton: {
        right: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

    const DialogTitle = withStyles(styles)((props) => {
      const { children, classes, onClose, ...other } = props;
      return (
        <MuiDialogTitle disableTypography className={classes.root} {...other} >
          <Typography
            variant="h6"
            style={{
              color: "#333",
              fontFamily: 'Public Sans',
              fontSize: '20px',
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            {children}
          </Typography>

          <IconButton onClick={this.toggle} >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
      );
    });

    return (
      <Dialog
        open={isOpen}
        toggle={this.toggle}
        maxWidth="md"
        fullWidth={false}
        aria-labelledby="responsive-dialog-title"
        onEnter={this.onOpened}
        onClosed={this.onExit}
      >
        <DialogTitle toggle={this.toggle}>{`Buscar ${this.breadCrumb}`}</DialogTitle>

        <DialogContent dividers>
          <div>
            <Typography
              style={{
                fontFamily: 'Public Sans',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '14px',
                letterSpacing: '0px',
                textAlign: 'left',
                color: '#676A71'
              }}
            >
              {`Para buscar pelos ${this.breadCrumb}, não é necessário preencher todos os campos. Busque pelo que deseja filtrar.`}
            </Typography>
          </div>

          <Grid container style={{ width: '100%', overflow: 'auto' }}>
            {this.renderFormObjeto()}
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "12px 30px 12px 0px" }}>
          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              background: "#E4E4E4",
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}
            onClick={this.toggle}
          >
            <Typography
              style={{
                color: "#878787",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',
              }}
            >
              Cancelar
            </Typography>
          </Button>
          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              backgroundColor: themes.primary,
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}
            onClick={() => { this.handleSubmit() }}
          >
            <Typography
              style={{
                color: "#FFFFFF",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',
              }}
            >
              Buscar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
BaseFiltroAvancadoListaItem.contextType = ThemeContext;
export default BaseFiltroAvancadoListaItem;
